import axios from "axios";
import { useMainStore } from "@/store";
import router from "@/router";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Tambahkan token ke setiap request
axios.interceptors.request.use(
  (config) => {
    const store = useMainStore();
    const token = store.token;

    if (token) {
      config.headers.Token = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor response untuk handle token error
axios.interceptors.response.use(
  (response) => {
    const store = useMainStore();
    const msg = (response.data?.msg || "").toLowerCase();
    const isErrorResponse = response.data?.status === false;
    const isTokenError = msg.includes("token");

    if (isErrorResponse && isTokenError) {
      store.showSnackbar("Sesi Anda telah berakhir. Silakan login kembali.");
      router.push("/logout?reason=expired");
    }

    return response;
  },
  (error) => {
    const store = useMainStore();
    store.showSnackbar("Terjadi kesalahan koneksi. Coba lagi.");
    return Promise.reject(error);
  }
);

export default axios;
